import React from 'react';
import { ZfTextButton } from '@zafire/react';
import { ContactNote } from './types/ContactNote.type';

type LinkedNotesTableProps = {
  notes: ContactNote[];
  onUnlink: (note: ContactNote) => void;
};

export const LinkedNotesTable: React.FC<LinkedNotesTableProps> = ({ notes, onUnlink }) => {
  return (
    <table
      style={{
        width: '100%',
        borderCollapse: 'collapse',
        textAlign: 'left',
      }}
    >
      <thead>
        <tr style={{ borderBottom: '1px solid #ccc' }}>
          <th style={{ padding: '8px' }}>Contact note ID</th>
          <th style={{ padding: '8px' }}>Partner(s)</th>
          <th style={{ padding: '8px' }}>BR(s)</th>
          <th style={{ padding: '8px' }}>Contact Date</th>
          <th style={{ padding: '8px' }}>Subject</th>
          <th style={{ padding: '8px' }}>Communication channel</th>
          <th style={{ padding: '8px' }}>Status</th>
          <th style={{ padding: '8px' }}>Qualified client contact</th>
          <th style={{ padding: '8px' }}>Source</th>
          <th style={{ padding: '8px' }}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {notes.map((note) => (
          <tr key={note.uid || note.id} style={{ borderBottom: '1px solid #eee' }}>
            <td style={{ padding: '8px' }}>{note.contactNoteId}</td>
            <td style={{ padding: '8px' }}>{(note.relatedPartners || []).map((p) => p.fullName).join(', ') || '-'}</td>
            <td style={{ padding: '8px' }}>{(note.relatedBRs || []).map((br) => br.masterNumber).join(', ') || '-'}</td>
            <td style={{ padding: '8px' }}>
              {note.startDateTime
                ? new Date(note.startDateTime).toLocaleDateString(undefined, {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                  })
                : '-'}
            </td>
            <td style={{ padding: '8px' }}>{note.subject}</td>
            <td style={{ padding: '8px' }}>{note.contactType}</td>
            <td style={{ padding: '8px' }}>{note.status}</td>
            <td style={{ padding: '8px' }}>{note.qualifiedClientContact ? 'Yes' : 'No'}</td>
            <td style={{ padding: '8px' }}>{note.source}</td>
            <td style={{ padding: '8px' }}>
              <ZfTextButton size="small" hierarchy="tertiary" onClick={() => onUnlink(note)}>
                Unlink
              </ZfTextButton>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
